import { CustomCategoryId, Category, CategoryBase } from '@wix/add-panel-common';
import type { FC } from 'react';
import type { WithCategory } from './CustomCategory.types';
import { UserImageCategoryView } from './UserImageCategoryView/UserImageCategoryView';

export const getCustomCategoryComponent = (category: CategoryBase | Category): FC<WithCategory> | null | never => {
  if (!category.isCustom && process.env.NODE_ENV !== 'production') {
    throw new Error(`Category ${category.id} is not custom category. Check your data.`);
  }

  switch (category.id) {
    case CustomCategoryId.UserImage:
      return UserImageCategoryView;
    default:
      return null;
  }
};

export const hasCustomCategoryComponent = (category: CategoryBase | Category): boolean =>
  Boolean(getCustomCategoryComponent(category));
